import Repository from "./Repository";

export default {
    search (team1, team2, seasons, competitions, languages, channels) {
        return Repository.new().get("/search", {team1: team1, team2: team2, seasons: seasons, competitions: competitions, languages: languages, channels: channels, from: "bdfutbol"});
    },
    languages () {
        return Repository.new().get("/languages");
    },
    teams () {
        return Repository.new().get("/teams");
    },
    competitions () {
        return Repository.new().get("/competitions");
    },
    seasons () {
        return Repository.new().get("/seasons");
    },
    channels () {
        return Repository.new().get("/channels");
    },
    contacts () {
        return Repository.new().get("/contacts");
    },
    send (params) {
        return Repository.new().post("/send", params);
    },
    send2 (params) {
        return Repository.new().post("/send-simple", params);
    },
    checkoutSession (params) {
        return Repository.new().post("/create-checkout-session", params);
    },
};
